import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/services/app-config.service';
import { SupportSujetRequest, SupportSujetUpdateRequest } from './support-sujet-model';

@Injectable({
  providedIn: 'root'
})
export class SupportSujetService {
  private apiUrl: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigService) {
    this.apiUrl = _appConfig.config.servicesBaseUrl;
   }

   getSupportSujets(connected: boolean): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    return this._http.get<any>(apiUrl + `/adm/template-mail/support/sujets?connected=` + connected, { observe: 'response' });
  }

  getSupportSujetById(supportSujetKey: string): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    return this._http.get<any>(apiUrl + `/adm/template-mail/support/sujets/` + supportSujetKey, { observe: 'response' });
  }

  add(supportSujetRequest: SupportSujetRequest): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    return this._http.post<SupportSujetRequest>(apiUrl + `/adm/template-mail/support/sujets/`, supportSujetRequest, { observe: 'response' });
  }

  update(supportSujetKey: number, supportSujetUpdateRequest: SupportSujetUpdateRequest, direction: string): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    return this._http.put<SupportSujetUpdateRequest>(apiUrl + `/adm/template-mail/support/sujets/` + supportSujetKey.toString() + `?direction=` + direction, supportSujetUpdateRequest, { observe: 'response' });
  }

  updateDisplayOrder(supportSujetKey: number, direction: string): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    return this._http.put<SupportSujetUpdateRequest>(apiUrl + `/adm/template-mail/support/sujets/` + supportSujetKey.toString() + `/order/` + direction, null, { observe: 'response' });
  }

  delete(supportSujetKey: number): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    return this._http.delete(apiUrl + `/adm/template-mail/support/sujets/` + supportSujetKey.toString(), { observe: 'response' });
  }

}
